/**
 * The phone's words for Keep Original or Compress (piece 9, *Image types and
 * compression*; piece 35, *The service report*; decisions 4652, 4621), asked when
 * a picture is added to a record's Files or to a visit's note, and spread into
 * the one string lookup.
 */
export const PICTURE_STRINGS = {
  'mobile.picture.title': 'Keep Original or Compress',
  'mobile.picture.type': 'Image Type',
  'mobile.picture.keep': 'Keep Original',
  'mobile.picture.compress': 'Compress',
  'mobile.picture.compressing': 'Compressing the picture…',
  'mobile.picture.pickType': 'Pick the image type first; its standard decides what Compress does.',
  'mobile.picture.shrinks': 'Compress shrinks it on the phone to {pixels} pixels on its long side, the size {type} keeps. The server crops and cleans it as before.',
  'mobile.picture.noStandard': '{type} has no size set yet, so the picture is sent as taken.',
  'mobile.picture.noDraw': 'The browser drew no picture.',
  'mobile.picture.notCompressed': 'The picture was not compressed on the phone:',
} as const;
